import React from "react";
import { Tooltip, Typography } from "@material-ui/core";
import BookmarksIcon from "@material-ui/icons/Bookmarks";
import BookmarkIcon from "@material-ui/icons/Bookmark";
import LaunchIcon from "@material-ui/icons/Launch";
import AppsIcon from "@material-ui/icons/Apps";
import TouchAppIcon from "@material-ui/icons/TouchApp";
import TreeItem from "@material-ui/lab/TreeItem";
import WarningIcon from "@material-ui/icons/Warning";
import { makeStyles } from "@material-ui/core/styles";
import { getLocalizedString } from "@icarius-localization/strings";
import Counter from "@icarius-common/counter";
import { useSelector } from "react-redux";
import { getAppColor } from "@icarius-app/selectors";

const useStyles = makeStyles({
    labelRoot: {
        display: "flex",
        alignItems: "center",
        gap: 5,
        minHeight: 28,
    },
});

const TreeBranch = (props) => {
    const { data, selectable, selectedIds, handleClick } = props;

    const classes = useStyles();
    const color = useSelector(getAppColor);

    const typeString = (() => {
        if (data.type === "MD") return getLocalizedString("module");
        if (data.type === "M") return getLocalizedString("menu");
        if (data.type === "S") return getLocalizedString("submenu");
        if (data.type === "B") return getLocalizedString("box");
        if (data.type === "G") return getLocalizedString("button");
        return "";
    })();

    const icon = (() => {
        if (data.type === "MD") return <BookmarksIcon />;
        if (data.type === "M") return <BookmarkIcon />;
        if (data.type === "S") return <AppsIcon />;
        if (data.type === "B") return <LaunchIcon />;
        if (data.type === "G") return <TouchAppIcon />;
        return null;
    })();

    return (
        <TreeItem
            onClick={() => {
                if (!selectable) return;
                if (handleClick) handleClick(data);
            }}
            nodeId={`${data.id}`}
            label={
                <div className={classes.labelRoot} style={{ background: selectedIds?.includes(data.id) ? color : "" }}>
                    {icon}
                    <Tooltip title={data.description} arrow>
                        <Typography variant="body2" style={{ paddingRight: 5 }}>
                            <span style={{ textDecoration: "underline" }}>{typeString}</span>
                            {typeString ? ": " : ""}
                            {data.name}
                        </Typography>
                    </Tooltip>
                    <Counter value={data.menus?.length} />
                    {!data.active && (
                        <Tooltip title={getLocalizedString("inactive")} arrow>
                            <WarningIcon color="primary" />
                        </Tooltip>
                    )}
                </div>
            }
        >
            {data.menus?.map((children, index) => {
                return (
                    <TreeBranch
                        key={index}
                        selectable={true}
                        data={children}
                        selectedIds={selectedIds}
                        handleClick={handleClick}
                    />
                );
            })}
        </TreeItem>
    );
};

export default TreeBranch;
